
import * as yup from 'yup'

const NAME_VALID = yup.string()
  .required('Please enter your name.');

const EMAIL_VALID = yup.string()
  .email('Please enter a valid email address.')
  .required('Please enter your email address.');

const QUESTION_VALID = yup.string()
  .required('Please input question.');

export {
  NAME_VALID,
  EMAIL_VALID,
  QUESTION_VALID
};